import styled from 'styled-components'


export const StyledSection = styled.div`
	position: relative;
	padding: 1.5em 0;
	&::before {
		position: absolute;
		top: -4px;
		content: '${({ label }) => label ? label : ''}';
	}
`
